export interface IStudentClassListItemDTO {
  id: string;
  className: string;
  classIcon: string;
  gradeLevel: string;
  schoolPeriodId: number;
}

export class StudentClassListItemDTO implements IStudentClassListItemDTO {
  id: string = '';
  className: string = '';
  classIcon: string = '';
  gradeLevel: string = '';
  schoolPeriodId: number = 0;

  constructor(configOverride?: Partial<IStudentClassListItemDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
